<template>
    <ul class="filter" v-if="isCasesPage">
        <li class="filter__item" v-if="solutions">
            <label class="filter__item-label">{{ dictionary.ArticlesSolutions }}</label>
            <div class="filter__item-container">
                <label class="filter__item-item" v-for="solutionItem in solutions" :key="solutionItem.Key">
                    <input type="checkbox" name="solution" v-model="solution" :value="solutionItem.Key"
                        :true-value="solutionItem.Key" false-value="" />
                    {{ solutionItem.Name }}
                </label>
            </div>
        </li>
        <li class="filter__item" v-if="countries">
            <label class="filter__item-label">{{ dictionary.ArticlesCountries }}</label>
            <div class="filter__item-container">
                <label class="filter__item-item" v-for="countryItem in countries" :key="countryItem.Key">
                    <input type="checkbox" name="solution" v-model="country" :value="countryItem.Key"
                        :true-value="countryItem.Key" false-value="" />
                    {{ countryItem.Name }}
                </label>
            </div>
        </li>
        <li class="filter__item" v-if="hasFilterApplied">
            <button type="button" @click="resetFilter">{{ dictionary.ArticlesResetFilter }}</button>
        </li>
    </ul>
    <ul class="articles-list__items articles-list__items-overview">
        <li v-for="(article, index) in articles" :key="article.Url" class="article-overview"
            v-show="index < visibleCount">
            <article class="article-case-item">
                <a :href="article.Url" class="article-case-item__link">
                    <div class="article-case-item__inner">
                        <div class="article-case-item__image">
                            <ResponsiveImage v-if="article.ImageForVue != null" :imageModel="article.ImageForVue" />
                        </div>
                        <div class="article-case-item__text">
                            <h3 class="article-case-item__headline">{{ article.Headline }}</h3>
                            <p class="article-case-item__teaser" v-if="article.HasTeaser">{{ article.Teaser }}</p>
                        </div>
                    </div>
                </a>
            </article>
        </li>
    </ul>
    <div class="articles-list__cta" v-show="hasMoreArticles">
        <a class="articles-list__load-more" @click="getNextPage" :disabled="isLoading">
            {{ dictionary.LoadMore }}
        </a>
    </div>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/articlesApi/getArticles";
export default {
    name: "Articles",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            solutions: [],
            contentTypes: [],
            countries: [],
            culture: "da-DK",
            articles: [],
            pageSize: 9,
            page: 1,
            totalArticles: 0,
            isLoading: false,
            hasLoadedInitials: false,
            articlesNodeId: 0,
            isCasesPage: false,
            sortorder: false,
            isResetting: false,
            visibleCount: 9,
        };
    },
    mixins: [
        bindRoute({
            solution: [],
            contentType: [],
            country: []
        }),
    ],
    watch: {
        solution: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        contentType: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        country: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        }
    },
    mounted() {
        this.articlesNodeId = this.$parent.articlesNodeId;
        this.pageSize = Number(this.$parent.pageSize);
        this.isCasesPage = this.$parent.isCasesPage === "True";
        this.sortorder = this.$parent.sortorder === "True";

        this.$router.isReady().then(() => {
            this.getInitialArticles();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getArticles(amountToSkip, pageSize, isCasesPage, sortorder, onComplete) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                articlesNodeId: vm.articlesNodeId,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize,
                isCasesPage: isCasesPage,
                sortorder: sortorder
            };

            if (vm.solution.length > 0) {
                object.solution = vm.solution;
            }

            if (vm.contentType.length > 0) {
                object.contentType = vm.contentType;
            }

            if (vm.country.length > 0) {
                object.country = vm.country;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    // Filter out any duplicates before adding
                    const existingUrls = new Set(vm.articles.map(a => a.Url));
                    const newArticles = data.Items.filter(item => !existingUrls.has(item.Url));
                    vm.articles.push(...newArticles);

                    vm.solutions = data.Facets.Solutions;
                    vm.contentTypes = data.Facets.ContentTypes;
                    vm.countries = data.Facets.Countries;
                    vm.dictionary = data.Dictionary;
                    vm.totalArticles = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;

                    if (typeof onComplete === "function") {
                        onComplete();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.visibleCount += 9;
            }
        },
        getInitialArticles() {
            // Get all cases up to, and including, the current page
            this.getArticles(0, this.pageSize, this.isCasesPage, this.sortorder, () => {
                const remaining = this.totalArticles - this.articles.length;
                if (remaining > 0) {
                    this.getArticles(this.articles.length, remaining, this.isCasesPage, this.sortorder);
                }
            });
        },
        filterChanged() {
            this.articles = [];
            this.totalArticles = 0;
            this.page = 1;
            this.visibleCount = this.pageSize;  // ← add this
            this.isResetting = true;

            this.getArticles(0, this.pageSize, this.isCasesPage, this.sortorder, () => {
                const remaining = this.totalArticles - this.articles.length;
                if (remaining > 0) {
                    this.getArticles(this.articles.length, remaining, this.isCasesPage, this.sortorder);
                }
            });
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.articles = [];
            vm.totalArticles = 0;
            vm.page = 1;
            vm.visibleCount = vm.pageSize;  // ← add this
            vm.solution = [];
            vm.contentType = [];
            vm.country = [];

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getArticles(0, vm.pageSize, vm.isCasesPage, vm.sortorder, () => {
                        const remaining = vm.totalArticles - vm.articles.length;
                        if (remaining > 0) {
                            vm.getArticles(vm.articles.length, remaining, vm.isCasesPage, vm.sortorder);
                        }
                    });
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreArticles() {
            return this.visibleCount < this.articles.length;
        },
        hasFilterApplied() {
            return this.solution.length > 0 ||
                this.contentType.length > 0 ||
                this.country.length > 0;
        }
    },
};
</script>